import 'jquery-ui/ui/widgets/datepicker';
import { PortalBaseViewController } from '@/views/portal/PortalBaseViewController';
import { TTAPI } from '@/services/TimeTrexClientAPI';
import { TTUUID } from '@/global/TTUUID';
import * as bootstrap from 'bootstrap';
import { JobApplicantEmploymentSubViewController } from '@/views/portal/hr/my_profile/JobApplicantEmploymentSubViewController';
import { JobApplicantReferenceSubViewController } from '@/views/portal/hr/my_profile/JobApplicantReferenceSubViewController';
import { JobApplicantLocationSubViewController } from '@/views/portal/hr/my_profile/JobApplicantLocationSubViewController';
import { JobApplicantSkillSubViewController } from '@/views/portal/hr/my_profile/JobApplicantSkillSubViewController';
import { JobApplicantSubBaseViewController } from '@/views/portal/hr/my_profile/JobApplicantSubBaseViewController';
import { JobApplicantEducationSubViewController } from '@/views/portal/hr/my_profile/JobApplicantEducationSubViewController';
import { JobApplicantMembershipSubViewController } from '@/views/portal/hr/my_profile/JobApplicantMembershipSubViewController';
import { JobApplicantLicenseSubViewController } from '@/views/portal/hr/my_profile/JobApplicantLicenseSubViewController';
import { JobApplicantLanguageSubViewController } from '@/views/portal/hr/my_profile/JobApplicantLanguageSubViewController';
import { JobApplicationSubViewController } from '@/views/portal/hr/my_profile/JobApplicationSubViewController';
import { DocumentSubViewController } from '@/views/portal/hr/my_profile/DocumentSubViewController';

export class MyProfileViewController extends PortalBaseViewController {
	constructor( options = {} ) {
		_.defaults( options, {
			el: '#my_profile_view',
			events: {
				'click #saveBtn': 'onSaveClick',
				'click #available_jobs': 'availableJobsClick',
				'click #applied_jobs': 'appliedJobsClick',
				'change input[type="text"]': 'onFormItemChange',
				'change input[type="checkbox"]': 'onFormItemChange',
				'change select.form-control': 'onFormItemChange',
				'change textarea.form-control': 'onFormItemChange',
				'click .detail-form-title': 'onFormTitleClick',
				'click .table-title .add-btn': 'onSubViewAddClick'
				// 'click .styled-select .glyphicon': 'onSelectClick',
			},
			// _required_files: [
			// 	'JobApplicantEmploymentSubViewController',
			// 	'JobApplicantReferenceSubViewController',
			// 	'JobApplicantLocationSubViewController',
			// 	'JobApplicantSkillSubViewController',
			// 	'JobApplicantEducationSubViewController',
			// 	'JobApplicantMembershipSubViewController',
			// 	'JobApplicantLicenseSubViewController',
			// 	'JobApplicantLanguageSubViewController',
			// 	'JobApplicationSubViewController',
			// 	'DocumentSubViewController'
			// ]
		} );

		super( options );
	}

	init() {
		if ( !Global.isSet( LocalCacheData.getPortalLoginUser() ) ) {
			return false;
		}

		this.current_edit_record = Global.clone( LocalCacheData.getPortalLoginUser() );
		this.model = new Backbone.Model( this.current_edit_record );
		this.viewId = 'MyProfile';

		// __non_webpack_require__( this._required_files, function() {
		this.api = TTAPI.APIJobApplicantPortal;
		this.company_api = TTAPI.APICompanyPortal;
		this.ethnic_group_api = TTAPI.APIEthnicGroupPortal;
		this.qualification_api = TTAPI.APIQualificationPortal;
		this.script_name = 'ProfileView';
		this.edit_view_error_ui_dic = {};
		this.applicant_fields = {};
		this.background_fields = {};
		this.availability_fields = {};
		this.employment_history_fields = {};
		this.reference_fields = {};
		this.location_fields = {};
		this.skill_fields = {};
		this.education_fields = {};
		this.membership_fields = {};
		this.license_fields = {};
		this.language_fields = {};
		this.enable_add_qualification_fields = {};
		this.is_changed = null;

		var $this = this;
		this.getAvailableFieldsForSection( function() {
			$this.render();
		} );
		// } );
	}

	refreshProfile() {
		var $this = this;
		this.api.getJobApplicant( {
			onResult: function( result ) {
				if ( result && result.isValid() ) {
					LocalCacheData.setPortalLoginUser( result.getResult()[0] );
					$this.current_edit_record = Global.clone( LocalCacheData.getPortalLoginUser() );
				}
				$this.$( '.job-applicant-detail' ).remove();
				$this.render();
			}
		} );
	}

	getAvailableFieldsForSection( callback ) {
		var $this = this;
		var sections;
		this.api.getRecruitmentPortalConfig( {}, {
			onResult: function( res ) {
				var result = res.getResult();
				if ( Global.isArray( result ) ) {
					sections = result[0];
				}

				if ( sections ) {
					for ( var section in sections ) {
						var section_available_fields_ids;
						if ( sections.hasOwnProperty( section ) ) {
							section_available_fields_ids = sections[section];
						}

						if ( Global.isArray( section_available_fields_ids ) ) {
							for ( var i = 0; i < section_available_fields_ids.length; i++ ) {
								var section_available_fields_id = section_available_fields_ids[i];
								$this[section + '_fields'][section_available_fields_id] = true;
							}
						}
					}
				}
				$this.api.getJobApplicant( {
					onResult: function( result ) {
						if ( result && result.isValid() ) {
							LocalCacheData.setPortalLoginUser( result.getResult()[0] );
							$this.current_edit_record = Global.clone( LocalCacheData.getPortalLoginUser() );
						}

						if ( callback ) {
							callback();
						}
					}
				} );
			}
		} );
	}

	render() {
		var tpl = Global.loadWidget( 'views/portal/hr/my_profile/MyProfileDetailView.html' );
		this.$el.append( _.template( tpl )( {
			'applicant': this.applicant_fields,
			'background': this.background_fields,
			'availability': this.availability_fields,
			'employment_history': this.employment_history_fields,
			'reference': this.reference_fields,
			'location': this.location_fields,
			'skill': this.skill_fields,
			'education': this.education_fields,
			'membership': this.membership_fields,
			'license': this.license_fields,
			'language': this.language_fields
		} ) );
		this.initOptions();
		this.registerDatePicker();
		this.setCurrentEditRecordData();
		this.initSubHistoryView();
		this.initSubQualificationView();
		this.initSubApplicationView();
		this.initSubDocumentView();

		var $this = this;
		//Required to send the update credentials data into the api.
		$( '.portal-tables #password, .portal-tables #password_confirm' ).on( 'change', function( e ) {
			$this.onFormItemChange( e );
		} );
	}

	initOptions() {
		var $this = this;
		this.api.getJobApplicantOptions( 'sex', {
			onResult: function( result ) {
				$this.setSourceData( 'sex_id', result.getResult() );
			}
		} );
		this.ethnic_group_api.getEthnicGroup( { filter_columns: { 'id': true, 'name': true } }, true, {
			onResult: function( result ) {
				var res = result.getResult();
				var options = {};
				for ( var i in res ) {
					if ( !res.hasOwnProperty( i ) ) {
						continue;
					}
					var row = res[i];
					options[row.id] = $.i18n._( row.name );
				}
				$this.setSourceData( 'ethnic_group_id', options, true );
			}
		} );
		this.api.getJobApplicantOptions( 'minimum_wage_type', {
			onResult: function( result ) {
				$this.setSourceData( 'minimum_wage_type_id', result.getResult(), true );
			}
		} );
		this.company_api.getOptions( 'country', {
			onResult: function( result ) {
				var result = result.getResult();
				$this.setSourceData( 'country', result, true );
				$this.setSourceData( 'identification_country', result, true );
			}
		} );
		this.api.getJobApplicantOptions( 'identification_type', {
			onResult: function( result ) {
				$this.setSourceData( 'identification_type_id', result.getResult(), true );
			}
		} );
		this.api.getJobApplicantOptions( 'available_days_of_week', {
			onResult: function( result ) {
				$this.setSourceData( 'available_days_of_week', result.getResult(), true );
			}
		} );
		this.api.getJobApplicantOptions( 'available_hours_of_day', {
			onResult: function( result ) {
				$this.setSourceData( 'available_hours_of_day', result.getResult(), true );
			}
		} );
	}

	onSelectClick( e ) {
		var elem = $( e.currentTarget ).parent().find( 'select' );
		if ( document.createEvent ) {
			var e = document.createEvent( 'MouseEvents' );
			e.initMouseEvent( 'mousedown', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null );
			elem[0].dispatchEvent( e );
		} else if ( element.fireEvent ) {
			elem[0].fireEvent( 'onmousedown' );
		}
	}

	registerDatePicker() {
		var time_format = 'h:mm TT';
		var format = 'dd-M-y';
		var focus_out_timer;
		var is_open = false;
		// When portal mode, no user preference.
		// if ( LocalCacheData.getLoginUserPreference() ) {
		// 	format = LocalCacheData.getLoginUserPreference().date_format_1;
		// 	time_format = LocalCacheData.getLoginUserPreference().time_format_1;
		// }
		var day_name_min = [
			$.i18n._( 'Sun' ), $.i18n._( 'Mon' ), $.i18n._( 'Tue' ),
			$.i18n._( 'Wed' ), $.i18n._( 'Thu' ), $.i18n._( 'Fri' ), $.i18n._( 'Sat' )
		];
		var month_name_short = [
			$.i18n._( 'Jan' ), $.i18n._( 'Feb' ),
			$.i18n._( 'Mar' ), $.i18n._( 'Apr' ), $.i18n._( 'May' ),
			$.i18n._( 'Jun' ), $.i18n._( 'Jul' ), $.i18n._( 'Aug' ),
			$.i18n._( 'Sep' ), $.i18n._( 'Oct' ), $.i18n._( 'Nov' ),
			$.i18n._( 'Dec' )
		];
		var current_text = $.i18n._( 'Today' );
		var close_text = $.i18n._( 'Close' );
		var options = {
			showTime: false,
			dateFormat: format,
			showHour: false,
			showMinute: false,
			changeMonth: true,
			changeYear: true,
			showButtonPanel: true,
			duration: '',
			showAnim: '',
			yearRange: '-100:+10',
			showOn: '',
			dayNamesMin: day_name_min,
			currentText: current_text,
			monthNamesShort: month_name_short,
			closeText: close_text,
			beforeShow: function() {
			},
			onSelect: function( dateText ) {
				$( this ).change();
			},
			onClose: function() {
				focus_out_timer = setTimeout( function() {
					is_open = false;
				}, 100 );
			}

		};
		this.$( 'input[type="text"].datepicker' ).datepicker( options );
		// if ( LocalCacheData.getLoginUserPreference() ) {
		// 	this.$('input[type="text"].datepicker').attr( 'placeholder', LocalCacheData.getLoginUserPreference().date_format_display );
		// } else {
		// 	this.$('input[type="text"].datepicker').attr( 'placeholder', 'dd-mmm-yy' );
		// }
		this.$( 'input[type="text"].datepicker' ).attr( 'placeholder', 'dd-mmm-yy' );
		this.$( 'input[type="text"].datepicker' ).bind( 'mouseup', function() {
			if ( !is_open ) {
				$( this ).datepicker( 'show' );
				is_open = true;
			} else {
				is_open = false;
				if ( focus_out_timer ) {
					clearTimeout( focus_out_timer );
					focus_out_timer = null;
				}
			}
		} ).next('.glyphicon').bind( 'mouseup', function() { $(this).prev().trigger( 'mouseup' ) } ); // this allows clicking on the calendar icon as well as the input box
	}

	setSourceData( field, source_data, set_empty ) {
		var $this = this;
		var field_selector = 'select[id="' + field + '"]';
		if ( this.$( field_selector ) && this.$( field_selector )[0] ) {
			this.$( field_selector ).empty();
		} else {
			return;
		}
		if ( _.size( source_data ) == 0 ) {
			set_empty = true;
		}
		if ( set_empty === true ) {
			if ( field === 'available_days_of_week' || field === 'available_hours_of_day' ) {
				this.$( field_selector ).append( $( '<option></option>' ).prop( 'value', '0' ).text( '-- ' + $.i18n._( 'Select all that apply' ) + ' --' ).attr( 'selected', 'selected' ) );
			} else {
				this.$( field_selector ).append( $( '<option></option>' ).prop( 'value', '0' ).text( '-- ' + $.i18n._( 'None' ) + ' --' ).attr( 'selected', 'selected' ) );
			}
		}
		if ( _.size( source_data ) > 0 ) {
			$.each( source_data, function( value, label ) {
				$this.$( field_selector ).append( $( '<option></option>' ).prop( 'value', value ).text( label ) );
				if ( field === 'available_days_of_week' || field === 'available_hours_of_day' ) {
					if ( _.isArray( $this.current_edit_record[field] ) ) {
						$this.$( field_selector ).find( 'option[value=\'0\']' ).removeAttr( 'selected' );
						var weeks = $this.current_edit_record[field];
						for ( var i = 0; i < weeks.length; i++ ) {
							if ( value == weeks[i] ) {
								$this.$( field_selector ).find( 'option[value=\'' + value + '\']' ).attr( 'selected', 'selected' );
							}
						}
					}
				} else {
					if ( $this.current_edit_record[field] == value ) {
						$this.$( field_selector ).val( value );
					}
				}

			} );
		}
		$this.$( field_selector ).selectpicker();
	}

	setCurrentEditRecordData() {
		var field_selector;
		var field_control;
		//Set current edit record data to all widgets
		for ( var key in this.current_edit_record ) {
			if ( !this.current_edit_record.hasOwnProperty( key ) ) {
				continue;
			}
			// if ( this.current_edit_record[key] === false ) {
			// 	this.current_edit_record[key] = '';
			// }
			switch ( key ) {
				case 'country':
				case 'identification_country':
					// if ( this.current_edit_record[key] === false ) {
					// 	this.current_edit_record[key] = '';
					// }
					// field_selector = 'select[id="' + key + '"]';
					// this.$(field_selector ).val( this.current_edit_record[key] );
					if ( key === 'country' ) {
						this.eSetProvince( this.current_edit_record[key] );
					} else if ( key === 'identification_country' ) {
						this.iSetProvince( this.current_edit_record[key] );
					}
					break;
				case 'currently_employed':
				case 'immediate_drug_test':
				case 'criminal_record':
					field_selector = 'input[id="' + key + '"]';
					if ( this.current_edit_record[key] === true ) {
						this.$( field_selector ).prop( 'checked', 'checked' );
						if ( this.$( 'textarea[id="criminal_record_description"]' )[0] ) {
							if ( key === 'criminal_record' ) {
								this.$( 'textarea[id="criminal_record_description"]' ).removeAttr( 'disabled' );
								this.$( 'textarea[id="criminal_record_description"]' ).css( 'background-color', '#fff' );
							} else {
								this.$( 'textarea[id="criminal_record_description"]' ).attr( 'disabled', 'disabled' );
								this.$( 'textarea[id="criminal_record_description"]' ).css( 'background-color', '#eee' );
							}
						}
					} else if ( this.current_edit_record[key] === false ) {
						this.$( field_selector ).removeAttr( 'checked' );
						if ( this.$( 'textarea[id="criminal_record_description"]' )[0] ) {
							this.$( 'textarea[id="criminal_record_description"]' ).attr( 'disabled', 'disabled' );
							this.$( 'textarea[id="criminal_record_description"]' ).css( 'background-color', '#eee' );
						}
					}
					break;
				// case 'available_days_of_week':
				// case 'identification_type_id':
				// case 'ethnic_group_id':
				// case 'sex_id':
				// 	break;
				default:
					if ( this.current_edit_record[key] === false ) {
						this.current_edit_record[key] = '';
					}
					field_selector = '.form-control[id="' + key + '"]';
					field_control = this.$( field_selector );
					if ( field_control && field_control[0] ) {
						this.$( field_selector ).val( this.current_edit_record[key] );
					}
					break;

			}
		}

		// this.collectUIDataToCurrentEditRecord();
		// this.setEditViewDataDone();
	}

	onFormItemChange( e, doNotValidate ) {
		if ( e.currentTarget.name ) {
			var key = e.currentTarget.name;
		} else if ( e.currentTarget.id ) {
			var key = e.currentTarget.id;
		} else {
			return false;
		}

		var $this = this;
		this.current_edit_record[key] = $( e.currentTarget ).val();
		this.model.set( key, $( e.currentTarget ).val() );
		this.is_changed = true;
		switch ( key ) {
			// case 'country':
			// case 'identification_country':
			// 	var widget = this.$('select[id="' + key + '"]');
			// 	widget.val( null );
			// 	break;
			case 'currently_employed':
			case 'immediate_drug_test':
			case 'criminal_record':
				if ( $( e.currentTarget ).is( ':checked' ) ) {
					this.current_edit_record[key] = true;
					this.model.set( key, true );
					if ( key === 'criminal_record' ) {
						if ( this.$( 'textarea[id="criminal_record_description"]' )[0] ) {
							this.$( 'textarea[id="criminal_record_description"]' ).removeAttr( 'disabled' );
							this.$( 'textarea[id="criminal_record_description"]' ).css( 'background-color', '#fff' );
						}
					}
				} else {
					this.current_edit_record[key] = false;
					this.model.set( key, false );
					if ( key === 'criminal_record' ) {
						if ( this.$( 'textarea[id="criminal_record_description"]' )[0] ) {
							this.$( 'textarea[id="criminal_record_description"]' ).attr( 'disabled', 'disabled' );
							this.$( 'textarea[id="criminal_record_description"]' ).css( 'background-color', '#eee' );
						}
					}
				}
				break;
			case 'available_days_of_week':
			case 'available_hours_of_day':
				if ( $( e.currentTarget ).val() === null ) {
					this.current_edit_record[key] = 0;
				}
				break;
			case 'confirm_password':
				doNotValidate = false;
				break;
		}
		if ( key == 'country' ) {
			this.eSetProvince( this.$( 'select[id="country"]' ).val(), true, function() {
				$this.validate();
			} );
			return;
		}
		if ( key === 'identification_country' ) {
			this.iSetProvince( this.$( 'select[id="identification_country"]' ).val(), true, function() {
				$this.validate();
			} );
			return;
		}
		if ( !doNotValidate ) {
			this.validate();
		}
	}

	validate() {
		var $this = this;
		var record = this.current_edit_record;
		this.api.validateJobApplicant( record, {
			onResult: function( result ) {
				$this.validateResult( result );
			}
		} );
	}

	validateResult( result ) {
		this.clearErrorTips();
		this.setErrorTips( result );
	}

	clearErrorTips( clear_all ) {
		Global.removeErrorTips( Object.values( this.edit_view_error_ui_dic ).map( item => item[0] ), clear_all );
	}

	setErrorTips( result ) {
		this.clearErrorTips( true );
		var error_list = result.getDetails() ? result.getDetails()[0] : {};
		if ( error_list && error_list.hasOwnProperty( 'error' ) ) {
			error_list = error_list.error;
		}
		var sort_array = [];
		if ( _.size( error_list ) > 0 ) {
			this.$( '.save-btn' ).addClass( 'error' );
		} else {
			this.$( '.save-btn' ).removeClass( 'error' );
		}
		for ( var key in error_list ) {
			if ( !error_list.hasOwnProperty( key ) ) {
				continue;
			}
			var field_obj;
			if ( this.$( 'input[id="' + key + '"]:visible' )[0] ) {
				field_obj = this.$( 'input[id="' + key + '"]:visible' );
			} else if ( this.$( 'select[id="' + key + '"]:visible' )[0] ) {
				field_obj = this.$( 'select[id="' + key + '"]:visible' ).parents( '.styled-select' );
			} else if ( this.$( 'textarea[id="' + key + '"]:visible' )[0] ) {
				field_obj = this.$( 'textarea[id="' + key + '"]:visible' );
			}
			if ( field_obj ) {

				field_obj.addClass( 'error-tip' );
				var error_string;
				if ( _.isArray( error_list[key] ) ) {
					error_string = error_list[key][0];
				} else {
					error_string = error_list[key];
				}

				var tooltip = new bootstrap.Tooltip(field_obj.get(0), {
					'title': error_string,
					'placement': 'right',
					'selector': '#' + key,
				});

				tooltip.show();

				this.edit_view_error_ui_dic[key] = field_obj;
				sort_array.push( field_obj.attr( 'data-sort' ) );
			}
		}
		if ( sort_array.length > 0 ) {
			sort_array.sort();
			var error_top_object;
			var key = sort_array[0];
			if ( this.$( 'input[data-sort="' + key + '"]' )[0] ) {
				error_top_object = this.$( 'input[data-sort="' + key + '"]' );
			} else if ( this.$( 'select[data-sort="' + key + '"]' )[0] ) {
				error_top_object = this.$( 'select[data-sort="' + key + '"]' );
			} else if ( this.$( 'textarea[data-sort="' + key + '"]' )[0] ) {
				error_top_object = this.$( 'textarea[data-sort="' + key + '"]' );
			}
			var page = $( 'html, body' );
			page.on( 'scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function( e ) {
				if ( e.which > 0 || e.type == 'mousedown' || e.type == 'mousewheel' || e.type == 'touchmove' ) {
					page.stop();
				}
			} );
			if ( error_top_object ) {
				page.animate( { scrollTop: error_top_object.parent().find( '.error-tip' ).offset().top }, 'slow', function() {
					page.off( 'scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove' );
				} );
			}
		}
	}

	eSetProvince( val, refresh, callback ) {
		var $this = this;
		$this.$( 'select[id="province"]' ).selectpicker( 'destroy' );
		if ( !val || val === '-1' || val === '0' ) {
			$this.e_province_array = [];
			$this.setSourceData( 'province', [] );
		} else {
			this.company_api.getOptions( 'province', val, {
				onResult: function( res ) {
					res = res.getResult();
					if ( !res ) {
						res = [];
					}
					$this.e_province_array = Global.buildRecordArray( res );
					if ( refresh && $this.e_province_array.length > 0 ) {
						$this.current_edit_record.province = $this.e_province_array[0].value;
						$this.model.set( 'province', $this.e_province_array[0].value );
						$this.$( 'select[id="province"]' ).val( $this.current_edit_record.province );
					}
					$this.setSourceData( 'province', res );
					if ( callback ) {
						callback();
					}
				}
			} );
		}
	}

	iSetProvince( val, refresh, callback ) {
		var $this = this;
		$this.$( 'select[id="identification_province"]' ).selectpicker( 'destroy' );
		if ( !val || val === '-1' || val === '0' ) {
			$this.i_province_array = [];
			$this.setSourceData( 'identification_province', [] );
		} else {
			this.company_api.getOptions( 'province', val, {
				onResult: function( res ) {
					res = res.getResult();
					if ( !res ) {
						res = [];
					}

					$this.i_province_array = Global.buildRecordArray( res );
					if ( refresh && $this.i_province_array.length > 0 ) {
						$this.current_edit_record.identification_province = $this.i_province_array[0].value;
						$this.model.set( 'identification_province', $this.i_province_array[0].value );
						$this.$( 'select[id="identification_province"]' ).val( $this.current_edit_record.identification_province );
					}
					$this.setSourceData( 'identification_province', res );
					if ( callback ) {
						callback();
					}
				}
			} );
		}
	}

	availableJobsClick() {
		window.location = Global.getBaseURL( null, true, true ).replace(/#!m=.*?(&|$)/g, '#!m=PortalJobVacancy$1'); //Be sure to include any other URL args.
		LocalCacheData.setAllURLArgs( {} );
	}

	appliedJobsClick() {
		window.location = Global.getBaseURL( null, true, true ).replace(/#!m=.*?(&|$)/g, '#!m=MyJobApplication$1'); //Be sure to include any other URL args.
		LocalCacheData.setAllURLArgs( {} );
	}

	onSaveClick() {
		this.clearErrorTips( true );
		var $this = this;
		// if ( _.size(this.edit_view_error_ui_dic) > 0 ) {
		// 	return;
		// }
		this.api.setJobApplicant( this.current_edit_record, {
			onResult: function( result ) {
				if ( result && result.isValid() ) {
					$this.is_changed = null;
					$this.showAlert( $.i18n._( 'Profile Saved Successfully!' ), {
						style: {
							'border': '2px solid #154575',
							'color': '#154575'
						}
					} );
					$this.api.getJobApplicant( {
						onResult: function( result ) {
							if ( result && result.isValid() ) {
								$this.$( '#saveBtn' ).removeClass( 'error' );
								$this.edit_view_error_ui_dic = {};
								LocalCacheData.setPortalLoginUser( result.getResult()[0] );
								IndexViewController.instance.router.headerView.render();
								// $this.initEditViewData();
							} else {
								$this.showErrorAlert( result );
								ProgressBar.closeOverlay();
							}
						}
					} );
				} else {
					$this.setErrorTips( result );
				}
			}
		} );
	}

	showErrorAlert( result ) {
		var details = result.getDetails();

		if ( details.hasOwnProperty( 'error' ) ) {

		}
		if ( !details ) {
			details = result.getDescription(); // If the details is empty, try to get description to show.
		}
		var error_string = '';

		if ( Global.isArray( details ) || typeof details === 'object' ) {

			$.each( details, function( index, val ) {

				if ( val.hasOwnProperty( 'error' ) ) {
					val = val.error;
				}

				for ( var key in val ) {
					error_string = error_string + val[key] + '<br>';
				}
			} );
		} else {

			error_string = details;
		}

		this.showAlert( error_string );
	}

	showAlert( content, options ) {
		IndexViewController.instance.router.showTipModal( content, options );
	}

	onFormTitleClick( e ) {
		this.toggleSubViews( e );
		$( 'span.glyphicon', e.currentTarget ).toggleClass( 'glyphicon-chevron-up glyphicon-chevron-down' );
		setTimeout( function() {
			$( e.currentTarget ).toggleClass( 'title-expand title-pack-up' );
		}, 500 );
	}

	toggleSubViews( e ) {
		var current_target_id = $( e.currentTarget ).attr( 'id' );
		var target = '.' + current_target_id;
		this.$( target ).slideToggle( 'row-expand row-pack-up' );
	}

	initSubHistoryView() {
		var history_views = [
			'JobApplicantEmployment', 'JobApplicantReference', 'JobApplicantLocation'
		];
		for ( var key in history_views ) {
			this.initSubViews( history_views[key] );
		}
	}

	initSubQualificationView() {
		// var qualification_views = [
		// 	'JobApplicantSkill', 'JobApplicantEducation', 'JobApplicantMembership', 'JobApplicantLicense', 'JobApplicantLanguage'
		// ];
		// for( var key in qualification_views ) {
		// 	this.initSubViews( qualification_views[key] );
		// }
		this.initSubViews( 'JobApplicantSkill', { type_id: 10 } );
		this.initSubViews( 'JobApplicantEducation', { type_id: 20 } );
		this.initSubViews( 'JobApplicantLicense', { type_id: 30 } );
		this.initSubViews( 'JobApplicantLanguage', { type_id: 40 } );
		this.initSubViews( 'JobApplicantMembership', { type_id: 50 } );
	}

	initSubApplicationView() {
		this.initSubViews( 'JobApplication' );
	}

	initSubDocumentView() {
		this.initSubViews( 'Document' );
	}

	initSubViews( sub_view_id, options ) {
		var $this = this;
		switch ( sub_view_id ) {
			case 'JobApplication':
				var all_columns = {
					'job_vacancy': $.i18n._( 'Job Vacancy' ),
					'created_date': $.i18n._( 'Date' )
				};
				this.setSubViews( sub_view_id, all_columns );
				break;
			case 'Document':
				var all_columns = {
					'name': $.i18n._( 'Name' ),
					'created_date': $.i18n._( 'Uploaded Date' )
				};
				this.setSubViews( sub_view_id, all_columns, options );
				break;
			case 'JobApplicantSkill':
			case 'JobApplicantEducation':
			case 'JobApplicantMembership':
			case 'JobApplicantLicense':
			case 'JobApplicantLanguage':
				var args = {};
				var filter_data = {};
				filter_data.type_id = [options.type_id];
				args.filter_data = filter_data;
				args.filter_columns = {
					'id': true,
					'name': true
				};
				this.qualification_api.getQualification( args, true, {
					onResult: function( result ) {
						var res = result.getResult();
						if ( res === true && $this.isEnableAddQualification( sub_view_id ) === false ) {
							$this.$( '.' + sub_view_id + '-table' ).parent().parent().css( 'display', 'none' );
							return;
						} else {
							$this.showQualificationHeader();
							$this.getAllColumns( sub_view_id, function( all_columns ) {
								$this.setSubViews( sub_view_id, all_columns );
							} );
						}
					}
				} );
				break;
			default:
				this.getAllColumns( sub_view_id, function( all_columns ) {
					$this.setSubViews( sub_view_id, all_columns );
				} );
				break;
		}
	}

	showQualificationHeader() {
		this.$( '#qualifications-tables' ).show();
	}

	isEnableAddQualification( sub_view_id ) {
		var is_enable;
		switch ( sub_view_id ) {
			case 'JobApplicantSkill':
				is_enable = this.enable_add_qualification_fields.hasOwnProperty( 'skill' ) && this.enable_add_qualification_fields.skill === true;
				break;
			case 'JobApplicantEducation':
				is_enable = this.enable_add_qualification_fields.hasOwnProperty( 'education' ) && this.enable_add_qualification_fields.education === true;
				break;
			case 'JobApplicantMembership':
				is_enable = this.enable_add_qualification_fields.hasOwnProperty( 'membership' ) && this.enable_add_qualification_fields.membership === true;
				break;
			case 'JobApplicantLicense':
				is_enable = this.enable_add_qualification_fields.hasOwnProperty( 'license' ) && this.enable_add_qualification_fields.license === true;
				break;
			case 'JobApplicantLanguage':
				is_enable = this.enable_add_qualification_fields.hasOwnProperty( 'language' ) && this.enable_add_qualification_fields.language === true;
				break;
		}
		return is_enable;
	}

	addDocumentRow( document_id ) {
		var $this = this;
		var options = {};
		options.filter_data = {
			id: document_id
		};
		options.append = true;
		this.initSubViews( 'Document', options );
		// $('html, body').animate({
		// 	scrollTop: $this.$('.Document-table').offset().top
		// }, 2000);
	}

	getAllColumns( sub_view_id, callBack ) {
		var $this = this;
		var method = 'get' + sub_view_id + 'Options';
		this.api[method]( 'columns', {
			onResult: function( columns_result ) {
				var columns_result_data = columns_result.getResult();
				if ( callBack ) {
					callBack( columns_result_data );
				}
			}
		} );
	}

	setSubViews( sub_view_id, display_columns, options ) {
		var $this = this;
		var filter = {};
		filter.filter_data = {};
		filter.filter_sort = {};
		// filter.filter_columns = this.getFilterColumnsFromDisplayColumns( display_columns );
		filter.filter_items_per_page = 0; // Default to 0 to load user preference defined
		filter.filter_page = 1;
		if ( Global.isSet( options ) && Global.isSet( options.filter_data ) ) {
			filter.filter_data = options.filter_data;
		}
		this.api['get' + sub_view_id]( filter, true, {
			onResult: function( result ) {
				var result_data = result.getResult();
				var container = '.' + sub_view_id + '-table';
				if ( !Global.isSet( options ) || ( Global.isSet( options ) && !options.append ) ) {
					$this.$( container ).empty();
				}
				if ( !Global.isArray( result_data ) && !( TTUUID.isUUID( $this.refresh_id ) ) ) {
					$this.$( container ).html( '<h4 class="no-result">' + $.i18n._( 'None provided yet, click the ' + '"+"' + ' icon to add' ) + '</h4>' );
				} else {
					// if ( $this.$('.'+sub_view_id+'-table').find('.table-container').length == 0 ) {
					// 	$this.$('.'+sub_view_id+'-table').html('<div class="table-responsive"><table class="table table-condensed table-bordered table-container"><thead></thead><tbody></tbody></table></div>');
					// }
					for ( var key in result_data ) {
						$this.initSubView( sub_view_id, display_columns, result_data[key] );
					}
				}
			}
		} );
	}

	initSubView( sub_view_id, display_columns, view_data ) {
		var $this = this;
		var sub_view_model = new Backbone.Model( view_data );
		var view_name = sub_view_id + 'SubViewController';
		var available_fields = null;
		var enable_add_qualification;
		switch ( sub_view_id ) {
			case 'JobApplicantEmployment':
				available_fields = this.employment_history_fields;
				break;
			case 'JobApplicantReference':
				available_fields = this.reference_fields;
				break;
			case 'JobApplicantLocation':
				available_fields = this.location_fields;
				break;
			case 'JobApplicantSkill':
				available_fields = this.skill_fields;
				enable_add_qualification = this.enable_add_qualification_fields.skill;
				break;
			case 'JobApplicantEducation':
				available_fields = this.education_fields;
				enable_add_qualification = this.enable_add_qualification_fields.education;
				break;
			case 'JobApplicantMembership':
				available_fields = this.membership_fields;
				enable_add_qualification = this.enable_add_qualification_fields.membership;
				break;
			case 'JobApplicantLicense':
				available_fields = this.license_fields;
				enable_add_qualification = this.enable_add_qualification_fields.license;
				break;
			case 'JobApplicantLanguage':
				available_fields = this.language_fields;
				enable_add_qualification = this.enable_add_qualification_fields.language;
				break;
			default:
				break;
		}

		switch ( view_name ) {
			case 'JobApplicantEmploymentSubViewController':
				var controller = JobApplicantEmploymentSubViewController
				break;
			case 'JobApplicantReferenceSubViewController':
				var controller = JobApplicantReferenceSubViewController
				break;
			case 'JobApplicantLocationSubViewController':
				var controller = JobApplicantLocationSubViewController
				break;
			case 'JobApplicantSkillSubViewController':
				var controller = JobApplicantSkillSubViewController
				break;
			case 'JobApplicantSubBaseViewController':
				var controller = JobApplicantSubBaseViewController
				break;
			case 'JobApplicantEducationSubViewController':
				var controller = JobApplicantEducationSubViewController
				break;
			case 'JobApplicantMembershipSubViewController':
				var controller = JobApplicantMembershipSubViewController
				break;
			case 'JobApplicantLicenseSubViewController':
				var controller = JobApplicantLicenseSubViewController
				break;
			case 'JobApplicantLanguageSubViewController':
				var controller = JobApplicantLanguageSubViewController
				break;
			case 'JobApplicationSubViewController':
				var controller = JobApplicationSubViewController
				break;
			case 'DocumentSubViewController':
				var controller = DocumentSubViewController
				break;

		}

		var sub_view_controller = new controller( {
					// table_container: $this.$('.'+sub_view_id+'-table').find('.table-container'),
					table_container: $this.$( '.' + sub_view_id + '-table' ),
					model: sub_view_model,
					sub_view_id: sub_view_id,
					_delegate: $this,
					available_fields: available_fields,
					enable_add_qualification: enable_add_qualification,
					display_columns: display_columns
				} );
	}

	onSubViewAddClick( e ) {
		var $this = this;
		var current_target_id = $( e.currentTarget ).attr( 'id' );
		var sub_view_id = current_target_id.split( '-' )[0];
		switch ( sub_view_id ) {
			case 'JobApplication':
				var all_columns = {
					'job_vacancy': $.i18n._( 'Job Vacancy' ),
					'created_date': $.i18n._( 'Date' )
				};
				$this.setSubViewsDefaultData( sub_view_id, all_columns );
				break;
			case 'Document':
				var all_columns = {
					'name': $.i18n._( 'Name' ),
					'created_date': $.i18n._( 'Uploaded Date' )
				};
				$this.setSubViewsDefaultData( sub_view_id, all_columns );
				break;
			default:
				this.getAllColumns( sub_view_id, function( all_columns ) {
					$this.setSubViewsDefaultData( sub_view_id, all_columns );
				} );
				break;
		}
	}

	setSubViewsDefaultData( sub_view_id, display_columns ) {
		var $this = this;
		if ( sub_view_id === 'JobApplication' ) {
			this.availableJobsClick();
			return;
		}
		this.api['get' + sub_view_id + 'DefaultData']( {
			onResult: function( result ) {
				var result_data = result.getResult();
				// if ( $this.$('.'+sub_view_id+'-table').find('.table-container').length == 0 ) {
				// 	$this.$('.'+sub_view_id+'-table').html('<div class="table-responsive"><table class="table table-condensed table-bordered table-container"><thead></thead><tbody></tbody></table></div>');
				// }
				$this.initSubView( sub_view_id, display_columns, result_data );
			}
		} );
	}

	getFilterColumnsFromDisplayColumns( display_columns ) {
		var column_filter = {};
		column_filter.is_owner = true;
		column_filter.id = true;
		column_filter.is_child = true;
		column_filter.in_use = true;
		column_filter.first_name = true;
		column_filter.last_name = true;
		column_filter.job_vacancy_id = true;

		// Error: Unable to get property 'getGridParam' of undefined or null reference
		//Fixed possible exception -- Error: Unable to get property 'length' of undefined or null reference in /interface/html5/views/BaseViewController.js?v=7.4.3-20140924-090129 line 5031
		// if ( display_columns ) {
		// 	var len = display_columns.length;
		//
		// 	for ( var i = 0; i < len; i++ ) {
		// 		var column_info = display_columns[i];
		// 		column_filter[column_info.name] = true;
		// 	}
		// }
		for ( var key in display_columns ) {
			column_filter[key] = true;
		}

		return column_filter;
	}

}

MyProfileViewController.html_template = `
<div id="my_profile_view">
	<div class="job-applicant-navbar">
		<div class="container">
			<div class="row">
				<div class="col-md-3 col-sm-12 col-xs-12">
					<button id="available_jobs" class="btn btn-block btn-default w-100"><span class="glyphicon glyphicon-menu-left"></span> <%= $.i18n._('Available Jobs') %></button>
				</div>
				<div class="col-md-3 col-sm-12 col-xs-12">
					<button id="applied_jobs" class="btn btn-block btn-default w-100"><%= $.i18n._('Applied Jobs') %></button>
				</div>
				<div class="col-md-2 col-sm-12 col-xs-12 offset-4">
					<button id="saveBtn" class="btn save-btn btn-block w-100"><%= $.i18n._('Save') %></button>
				</div>
			</div>
		</div>
	</div>
</div>
`;
